import { CsContextApiModel } from "../api-models";

// eslint-disable-next-line import/no-mutable-exports
export let csContext!: CsContextApiModel;

export function setCsContext(value: CsContextApiModel): void {
  csContext = value;
}
